import styled from '@emotion/styled';
import { EventHeaderCaptionWrapper } from 'src/domains/sportsbook/webview/components/sportEventsListNew/EventGroupHeaderUnified.style';
import { withConfig } from 'src/withConfig';

export const LineGroupedRoot = styled('div', { label: 'LineGroupedRoot' })`
    width: 100%;
`;

export const SelectionHeader = styled(EventHeaderCaptionWrapper, { label: 'SelectionHeader' })`
    align-items: stretch;
    display: flex;
    gap: 4px;
    justify-content: space-around;

    & [class$='EventHeaderCaption'] {
        width: 100%;
    }
`;

export const HeaderCell = withConfig(theme => styled('span', { label: 'HeaderCell' })`
    align-items: center;
    color: ${theme.star.unified.eventHeaderCaption.txtColorSecondary};
    display: flex;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.regular};
    justify-content: center;
    text-align: center;
    width: 100%;
`);

interface MarketRowsPropsType {
    $columnCount: number;
}

export const MarketRows = styled('div', { label: 'MarketRows' })<MarketRowsPropsType>`
    align-items: center;
    display: grid;
    grid-template-columns: repeat(${({ $columnCount }): number => $columnCount}, 1fr);
    padding: 0;
`;

export const LineCell = withConfig(theme => styled('div', { label: 'LineCell' })`
    color: ${theme.star.selectionsGroup.txtColor};
    font-size: ${theme.star.unified.eventRow.typography.fontSizePrimary};
    font-weight: ${theme.star.unified.eventRow.typography.fontWeightSecondary};
    border-bottom: 1px solid ${theme.star.unified.selection.borderColor};
    min-height: 61px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 8px 4px 8px;
`);

export const SelectionCell = withConfig(theme => styled('div', { label: 'SelectionCell' })`
    min-width: 0;
    width: 100%;
    border-bottom: 1px solid ${theme.star.unified.selection.borderColor};
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    padding: 8px 4px;

    &:has(+ [class$='LineCell']), &:last-of-type {
        padding-right: 8px;
    }

    .selection {
        display: flex;
        justify-content: center;
        flex: 1;
        align-self: stretch;
    }
`);
